import {
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc
} from 'firebase/firestore';
import { db } from '../firebase/config-v9';

const ANNOUNCEMENTS_COLLECTION = 'announcements';

const mapDoc = (snap) => ({
  id: snap.id,
  ...snap.data()
});

export const getAnnouncements = async () => {
  if (!db) {
    console.warn('⚠️ Firestore not initialized for announcements');
    return [];
  }
  const q = query(
    collection(db, ANNOUNCEMENTS_COLLECTION),
    orderBy('createdAt', 'desc')
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(mapDoc);
};

export const getActiveAnnouncements = async ({ limitTo = 1 } = {}) => {
  if (!db) {
    console.warn('⚠️ Firestore not initialized for announcements');
    return [];
  }
  const q = query(
    collection(db, ANNOUNCEMENTS_COLLECTION),
    where('isActive', '==', true),
    orderBy('createdAt', 'desc'),
    limit(limitTo)
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(mapDoc);
};

export const createAnnouncement = async (announcementData) => {
  if (!db) {
    console.warn('⚠️ Firestore not initialized for announcements');
    return { id: null };
  }
  const docRef = await addDoc(collection(db, ANNOUNCEMENTS_COLLECTION), {
    ...announcementData,
    createdAt: new Date(),
    updatedAt: new Date()
  });
  return { id: docRef.id };
};

export const updateAnnouncement = async (announcementId, updateData) => {
  if (!db) {
    console.warn('⚠️ Firestore not initialized for announcements');
    return { success: false };
  }
  await updateDoc(doc(db, ANNOUNCEMENTS_COLLECTION, announcementId), {
    ...updateData,
    updatedAt: new Date()
  });
  return { success: true };
};

export const deleteAnnouncement = async (announcementId) => {
  if (!db) {
    console.warn('⚠️ Firestore not initialized for announcements');
    return { success: false };
  }
  await deleteDoc(doc(db, ANNOUNCEMENTS_COLLECTION, announcementId));
  return { success: true };
};

export const toggleAnnouncementStatus = async (announcementId, isActive) => {
  if (!db) {
    console.warn('⚠️ Firestore not initialized for announcements');
    return { success: false };
  }
  await updateDoc(doc(db, ANNOUNCEMENTS_COLLECTION, announcementId), {
    isActive,
    updatedAt: new Date()
  });
  return { success: true };
};

export const getOfferAnnouncements = async () => {
  if (!db) {
    console.warn('⚠️ Firestore not initialized for announcements');
    return [];
  }
  const q = query(
    collection(db, ANNOUNCEMENTS_COLLECTION),
    where('isActive', '==', true),
    orderBy('createdAt', 'desc')
  );
  const snapshot = await getDocs(q);
  const allAnnouncements = snapshot.docs.map(mapDoc);
  return allAnnouncements.filter((announcement) => {
    const hasOfferCode = announcement.offerCode && announcement.offerCode.trim() !== '';
    const isOfferType = announcement.type === 'offer' || announcement.type === 'promotion';
    const hasOfferKeywords = announcement.message && (
      announcement.message.toLowerCase().includes('code') ||
      announcement.message.toLowerCase().includes('offer') ||
      announcement.message.toLowerCase().includes('discount')
    );
    return hasOfferCode || isOfferType || hasOfferKeywords;
  });
};

export const subscribeToActiveAnnouncementsService = (callback) => {
  let active = true;

  const run = () =>
    getActiveAnnouncements({ limitTo: 1 })
      .then((announcements) => {
        if (active) callback(announcements);
      })
      .catch(() => {
        if (active) callback([]);
      });

  if ('requestIdleCallback' in window) {
    requestIdleCallback(run);
  } else {
    setTimeout(run, 300);
  }

  return () => {
    active = false;
  };
};
